import styled from 'styled-components';

import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';

const AI_GRADIENT_STOPS = [
    [3, 74, 166, 0],
    [12, 128, 223, 25],
    [0, 141, 255, 45],
    [154, 85, 255, 70],
    [225, 84, 255, 100]
] as const;

const aiGradient = (alpha: number) =>
    `linear-gradient(90deg, ${AI_GRADIENT_STOPS.map(([r, g, b, stop]) => `rgba(${r}, ${g}, ${b}, ${alpha}) ${stop}%`).join(', ')})`;

export const AI_BORDER_GRADIENT = aiGradient(1);

const solidFill = (color: string) => `linear-gradient(${color}, ${color})`;

export const AiRowRoot = styled.div<{ theme: InterstateTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 40px;
    padding: 0 12px;
    border: 1px solid transparent;
    border-radius: 4px;
    background-origin: border-box;
    background-image: ${({ theme }) => `${solidFill(theme.tokens.SemColorSurfaceDefault)}, ${AI_BORDER_GRADIENT}`};
    background-clip: padding-box, border-box;
`;
